import { FullStory } from '@fullstory/browser';
import { getLogger } from '../lib/logger-plus';

const logger = getLogger('FullStory');

type FullStoryPrimitive = boolean | string | number | Date | null;

type FullStoryArray = boolean[] | string[] | number[] | Date[];

type FullStoryValue = FullStoryPrimitive | FullStoryArray | FullStoryObject;

interface FullStoryObject {
  [key: string]: FullStoryValue;
}

type FullStoryTypeDescriptors =
  | 'bool'
  | 'date'
  | 'int'
  | 'real'
  | 'str'
  | 'bools'
  | 'ints'
  | 'dates'
  | 'reals'
  | 'strs';

interface FullStorySchemaObject {
  [key: string]: FullStoryTypeDescriptors | FullStorySchemaObject;
}

/**
 * @see https://developer.fullstory.com/browser/custom-properties/
 */
export function trackEvent({
  name,
  properties = {},
  schema
}: {
  name: string;
  properties?: FullStoryObject;
  /** Should mirror the shape of properties, with FullStory type descriptors as leaf values */
  schema?: FullStorySchemaObject;
}) {
  if (typeof FullStory === 'function' && FullStory('getSession')) {
    FullStory('trackEvent', {
      name,
      properties,
      schema
    });
    return;
  }

  logger.info({ name, properties, schema }, 'FullStory not initialized, skipping event');
}
